import React, { useEffect, useState, useRef, useCallback } from 'react';

import styled from 'styled-components';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

import ImageGallery from '../Components/common/ImageGallery/ImageGallery';
import * as constNames from '../models/constant';

const MTGallaryModeComponent = ({
  galleryMode,
  isPhotoState,
  imageList,
  floorPlanImg,
  galleryModeCB,
  setPhotoIndexCB,
  toggleCarouselStateCB,
}) => {
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);
  const [selectedImageHeight, setSelectedImageHeight] = useState(0);

  const handleResize = useCallback(() => {
    const isPortrait = window.innerHeight > window.innerWidth;
    let newHeight;
    let newImageHeight;
    const carouselWrapperElement = document.querySelector('.image-gallery');

    setTimeout(() => {
      if (isPortrait) {
        newHeight = window.innerHeight - 116 + `px`;
        newImageHeight = ((window.innerWidth - 30) * 3) / 4 + 'px';
      } else {
        newHeight = 100 + `%`;
        if (window.innerWidth > 768) {
          newImageHeight = (680 * 3) / 4 + 'px';
        } else {
          newImageHeight = (350 * 3) / 4 + 'px';
        }
      }
      setWindowHeight(newHeight);
      setSelectedImageHeight('auto');
    }, 0);
  }, []);

  useEffect(() => {
    // Listen to resize event if you want to recalculate when the window resizes

    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  const setPhotoIndexCBChild = useCallback(
    (index) => {
      setPhotoIndexCB(index);
      setSelectedPhotoIndex(index);
    },
    [setPhotoIndexCB],
  );

  const toggleCarouselStateCBChild = useCallback(
    (state) => {
      toggleCarouselStateCB(state);
    },
    [toggleCarouselStateCB],
  );

  const toggleBodyScroll = useCallback((enable) => {
    if (enable) {
      document.body.style.overflow = 'auto';
    } else {
      document.body.style.overflow = 'hidden';
    }
  }, []);

  useEffect(() => {
    const carouselElement = document.querySelector('.slider-wrapper');

    function handleTouchStart() {
      toggleBodyScroll(false);
    }

    function handleTouchEnd() {
      toggleBodyScroll(true);
    }

    carouselElement.addEventListener('touchstart', handleTouchStart);

    carouselElement.addEventListener('touchend', handleTouchEnd);

    return () => {
      carouselElement.removeEventListener('touchstart', handleTouchStart);

      carouselElement.removeEventListener('touchend', handleTouchEnd);
    };
  }, [toggleBodyScroll]);

  useEffect(() => {
    // Initial calculation
    handleResize();
  }, [handleResize]);

  return (
    <GalleryModeWrapper
      galleryMode={galleryMode}
      windowHeight={windowHeight}
      selectedImageHeight={selectedImageHeight}
      isPhotoState={isPhotoState}
    >
      <BackArrowWrapper galleryMode={galleryMode} onClick={() => galleryModeCB(false)}>
        <ArrowBackOutlinedIcon /> Back{' '}
      </BackArrowWrapper>
      <div className="image-gallery-container">
        <div className="image-gallery-numbers">
          <span className="gallery-counter">
            {isPhotoState
              ? `${selectedPhotoIndex + 1}/${imageList.length}`
              : `${1}/${floorPlanImg?.length}`}
          </span>
        </div>
        <ImageGallery
          imageList={isPhotoState ? imageList : floorPlanImg}
          selectedItem={selectedPhotoIndex}
          onItemChange={(index) => setPhotoIndexCBChild(index)}
        />
        <ImageTabsWrapper className="image-tabs-wrapper">
          <button
            className={`buttonchildTab childTab1 ${
              isPhotoState ? 'buttonchildTabSecondary' : 'buttonchildTabPrimary'
            }`}
            onClick={() => toggleCarouselStateCBChild(constNames.FLOOR_PLAN)}
            title="Floor Plan"
          >
            Floor Plan
          </button>
          <button
            className={`buttonchildTab childTab2 ${
              isPhotoState ? 'buttonchildTabPrimary' : 'buttonchildTabSecondary'
            }`}
            onClick={() => toggleCarouselStateCBChild(constNames.PHOTOS)}
            title="Photos"
          >
            Photos
          </button>
        </ImageTabsWrapper>
      </div>
    </GalleryModeWrapper>
  );
};

export default MTGallaryModeComponent;

const GalleryModeWrapper = styled.div`
  & .slider.animated {
    height: ${(props) => props.selectedImageHeight};
    align-items: center;
    transform: translate3d(
      ${(props) => (props?.isPhotoState ? 'auto' : '0%')},
      0px,
      0px
    ) !important;
  }
  & .carousel.carousel-slider {
    @media (orientation: ${constNames.DEVICE_ORIENTATION.POTRAIT}) {
      overflow: visible;
    }
  }
  & .carousel .slide img {
    height: ${(props) => props.selectedImageHeight};
    object-fit: cover;
    border-radius: 8px;
    border: solid 1px #ddd;
    @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
        .LANDSCAPE}) {
    }
    @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
        .POTRAIT}) {
      max-width: ${({ galleryMode }) => (galleryMode ? '100% !important' : '')};
    }
  }
  .image-gallery-container {
    height: ${(props) => props.windowHeight};
    padding: 0;
    display: grid;
    align-items: center;
    justify-content: space-around;
    @media ${constNames.DEVICE_MEDIA.MOBILE_MAX} and (orientation: ${constNames.DEVICE_ORIENTATION
        .LANDSCAPE}) {
      height: auto;
      display: grid;
      grid-template-columns: 1fr 50px;
      align-items: center;
    }
    .image-gallery-numbers {
      text-align: center;
      @media ${constNames.DEVICE_MEDIA.MOBILE_MAX} and (orientation: ${constNames.DEVICE_ORIENTATION
          .LANDSCAPE}) {
        order: 2;
      }
    }
    .image-gallery {
      height: ${(props) => props.selectedImageHeight};
      @media ${constNames.DEVICE_MEDIA.MOBILE_MAX} and (orientation: ${constNames.DEVICE_ORIENTATION
          .LANDSCAPE}) {
        order: 1;
        width: 350px;
        margin: 0 auto;
      }
      @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
          .LANDSCAPE}) {
        width: 680px;
      }
    }
    .image-tabs-wrapper {
      @media ${constNames.DEVICE_MEDIA.MOBILE_MAX} and (orientation: ${constNames.DEVICE_ORIENTATION
          .LANDSCAPE}) {
        order: 3;
      }
    }
  }
  .carousel .control-dots {
    bottom: 15px;
    position: absolute;
    display: ${(props) => (props?.isPhotoState ? 'flex' : 'none')};
    @media (orientation: ${constNames.DEVICE_ORIENTATION.POTRAIT}) {
      bottom: -75px;
    }
    & span {
      margin-right: 20px;
      display: inline-block;
      border-radius: 50%;
      cursor: pointer;
    }
  }
  & .ellipsis-unselected {
    height: 18px;
    width: 18px;
    border: 1px solid #dfe6e5;
    margin-bottom: 2px;
    border: 1px solid rgb(255 255 255);
    background-color: rgb(3, 40, 66);
  }
  & .ellipsis-selected {
    height: 24px;
    width: 24px;
    border: 1px solid #fff;
    background-color: #003f2d;
  }
  .carousel .slider-wrapper {
    margin: 15px auto;
    width: 100%;
  }
`;

const ImageTabsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin:20px 0;
  align-self: end;
  & .buttonchildTab {
    padding: 3px 10px;
    display: flex;
    padding: 3.232px 10px 4.768px 10px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: none;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; 
    letter-spacing: 0.06px;
  }
  & .buttonchildTabPrimary {
    color: rgba(26, 26, 26, 0.46)
    background-color: rgba(26, 26, 26, 0.12);
  }
  & .buttonchildTabPrimary {
    color: #fff;
    background-color: #032842;
  }
  & .buttonchildTabSecondary{
    color: rgba(26, 26, 26, 0.60);
    background: rgba(26, 26, 26, 0.12);
  }
  & .childTab1 {
    justify-self: end;
  }
  & .childTab2 {
    justify-self: start;
  }
`;

const BackArrowWrapper = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 8px;
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .LANDSCAPE}),
    ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    position: relative;
    margin: 0 auto;
    order: ${({ galleryMode }) => (galleryMode ? '' : 2)};
  }

  & a {
    color: #1a1a1a;
    text-decoration: none;
    display: flex;
    align-items: center;
    & svg {
      margin-right: 5px;
    }
    @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
        .LANDSCAPE}),
      ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
        .POTRAIT}) {
      position: absolute;
      margin-left: -160px;
      margin-top: 15px;
    }
  }
`;
